import * as $runtime from "../runtime.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Restaumatic$dCart$dDetail from "../Restaumatic.Cart.Detail/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
const ProductItem = x => x;
const productItemUnitPrice = v => v.unitPrice;
const productItemSoftErrors = v => {
  if (v.errors.tag === "Just") {
    if (v.errors._1.tag === "Left") { return []; }
    if (v.errors._1.tag === "Right") { return v.errors._1._1; }
    $runtime.fail();
  }
  if (v.errors.tag === "Nothing") { return []; }
  $runtime.fail();
};
const productItemQuantity = v => v.quantity;
const productItemPrice = item => {
  if (item.unitPrice.tag === "Just") { return Data$dMaybe.$Maybe("Just", item.quantity * item.unitPrice._1 | 0); }
  return Data$dMaybe.Nothing;
};
const productItemNote = v => v.note;
const productItemKey = v => v.key;
const productItemFatalError = v => {
  if (v.errors.tag === "Just") {
    if (v.errors._1.tag === "Left") { return Data$dMaybe.$Maybe("Just", v.errors._1._1); }
    if (v.errors._1.tag === "Right") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  }
  return Data$dMaybe.Nothing;
};
const productItemExtendedKey = v => ({key: v.key, note: v.note});
const productItemErrors = v => v.errors;
const productItemDetails = v => v.details;
const newtypeProductItem = {Coercible0: () => {}};
const hasNoProductErrors = v => {
  if (v.errors.tag === "Nothing") { return true; }
  if (v.errors.tag === "Just") {
    if (v.errors._1.tag === "Right") { return v.errors._1._1.length === 0; }
    return false;
  }
  return false;
};
const genericProductItem = {to: x => x, from: x => x};
const showProductItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showSoftError.show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
              "details",
              (() => {
                if (v.details.tag === "Just") { return "(Just " + Restaumatic$dCart$dDetail.showProductDetails.show(v.details._1) + ")"; }
                if (v.details.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "errors",
              (() => {
                if (v.errors.tag === "Just") {
                  if (v.errors._1.tag === "Left") { return "(Just (Left " + Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showFatalError.show(v.errors._1._1) + "))"; }
                  if (v.errors._1.tag === "Right") { return "(Just (Right " + $0(v.errors._1._1) + "))"; }
                  $runtime.fail();
                }
                if (v.errors.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["key", Restaumatic$dCart$dProductKey.showProductKey.show(v.key)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "note",
              (() => {
                if (v.note.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.note._1) + ")"; }
                if (v.note.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["quantity", Data$dShow.showIntImpl(v.quantity)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "unitPrice",
              (() => {
                if (v.unitPrice.tag === "Just") { return "(Just " + Data$dMoney$dRounded.toString(v.unitPrice._1) + ")"; }
                if (v.unitPrice.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))([]))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "ProductItem"});
    return x => $0["genericShow'"](x);
  })()
};
export {
  ProductItem,
  genericProductItem,
  hasNoProductErrors,
  newtypeProductItem,
  productItemDetails,
  productItemErrors,
  productItemExtendedKey,
  productItemFatalError,
  productItemKey,
  productItemNote,
  productItemPrice,
  productItemQuantity,
  productItemSoftErrors,
  productItemUnitPrice,
  showProductItem
};
